import AssignRoleAction, { AssignRoleActionDTO } from 'models/onboarding/process/action/AssignRoleAction';

export default class AssignRoleActionService {
	toModel(process: AssignRoleActionDTO): AssignRoleAction {
		return new AssignRoleAction(process);
	}
}
